import { PostalAddress } from "../generated/lmsTypes";
import { Country } from "../generated/weblinkTypes";
import { COUNTRY_QUERY } from "../queries/country";
import { useWebLinkQuery } from "./weblink";

export const getEmptyPostalAddress = () => ({
  streetAddress1: null,
  streetAddress2: null,
  streetAddress3: null,
  town: null,
  postcode: null,
  province: { code: null },
  country: { id: null },
});

export const getPostalAddressInput = (postalAddress?: PostalAddress | null) => {
  if (!postalAddress) return null;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { country, province, __typename, ...restOfAddress } = postalAddress;
  return !country?.id &&
    !province?.code &&
    !Object.values(restOfAddress).filter(v => !!v).length
    ? null
    : {
        ...restOfAddress,
        countryId: country?.id,
        provinceCode: province?.code,
      };
};
export const useCountryList = () => {
  const { data, loading, error } = useWebLinkQuery(COUNTRY_QUERY, {
    fetchPolicy: "cache-first",
  });
  return {
    countryList:
      data?.countries.map(({ id, name, provinces }: Country) => ({
        code: id,
        name,
        provinces,
      })) ?? [],
    loading,
    error,
  };
};
